<mat-card class="login-card">
  <mat-card-header>
    <mat-card-title class="login-title">夏原工業 勤怠管理システムログイン</mat-card-title>
  </mat-card-header>
  <div class="errorMessage">{{errorMessage}}</div>
  <mat-card-content>
    <form (ngSubmit)="onSubmit()" class="login-form" #loginForm="ngForm">
      <mat-form-field>
        <input matInput placeholder="メールアドレス" id="key" [(ngModel)]="keySet.key" name="key" #key="ngModel" required>
        <mat-error *ngIf="key.invalid">メールアドレスの入力は必須です</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input [type]="hide ? 'password' : 'text'" matInput placeholder="パスワード" id="secret" [(ngModel)]="keySet.secret"
          name="secret" #secret="ngModel" autocomplete="off" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
        <mat-error *ngIf="secret.errors?.required">パスワードの入力は必須です</mat-error>
      </mat-form-field>
      <button type="submit" mat-raised-button color="primary" [disabled]="loginForm.invalid">ログイン</button>
    </form>
    <a href="/home/reset-password">パスワードを忘れた場合はこちら</a>
  </mat-card-content>
  <!-- <mat-card-content>
    <a href="./signup"> アカウントが無い場合はこちらから登録してください</a>
  </mat-card-content> -->
</mat-card>

<mat-card *ngIf="isTerminal" class="login-card">
  <button type="button" mat-raised-button color="primary" (click)="changeTerminalMode()">打刻機モードに切り替え</button>
</mat-card>
